export interface BootstrapDependencies {
  initialize: () => Promise<unknown>;
  prime: () => void;
  render: () => void;
  showConfigurationError: () => void;
}

/**
 * 將 runtime config 當作 BO 的啟動閘門；設定失敗時不容許任何 API 相關初始化。
 */
export async function bootstrap(
  dependencies: BootstrapDependencies
): Promise<void> {
  try {
    await dependencies.initialize();
  } catch {
    dependencies.showConfigurationError();
    return;
  }

  dependencies.prime();
  dependencies.render();
}
